 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		17: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		17: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"3389bff6287b4aeb654cc1f98a9267e7b42ee792","2":"7d3cbdf950d0a3bde754ba91eef34b965482edc6","3":"042631c427225e9cd2a5bcdbef5b3947ed27bf0c","4":"44cb58f2e6fcd2eb1a10482fdb18678762f45c15","5":"2e8e49993f43d1471daa31bd457ab8637269faad","6":"a4c92b5b","7":"f6d80b4e5bec7b791e989e1ab0e7288987f02f86","8":"7b209c3345d92abea6b160ffa2ab4dd01c3e6770","9":"a656cea4aeabd6d651c8f2159ba06833a393a493","10":"520d75254f688c45e52c1ae1f8615bb0a18b23ce","11":"775cbc166ccb32e641d59a874a2b48a4fb904795","12":"2293bb39a1229e2750f5acea87b7c8dedaf35036","13":"323e1820c5c978307575aa5c47801f0a64af9d3a","14":"6264b85f94d8b35da7cf020631ed05257c2868ad","15":"92581cf2c0a22e44ef923c0536027b96abf22498","16":"e528f9020b5aca1fa3959f28315315893f256883","19":"component---src-pages-404-jsx","20":"component---src-pages-attentive-vs-wunderkind-jsx","21":"component---src-pages-driverevenue-jsx","22":"component---src-pages-driverevenue-workshop-jsx","23":"component---src-pages-how-it-works-advertising-solutions-for-advertisers-and-publishers-jsx","24":"component---src-pages-how-it-works-advertising-solutions-for-advertisers-and-publishers-uk-jsx","25":"component---src-pages-how-it-works-performance-marketing-solutions-for-ecommerce-jsx","26":"component---src-pages-how-it-works-performance-marketing-solutions-for-ecommerce-uk-jsx","27":"component---src-pages-index-jsx","28":"component---src-pages-index-uk-jsx","29":"component---src-pages-listrak-vs-wunderkind-jsx","30":"component---src-pages-open-roles-jsx","31":"component---src-pages-open-roles-uk-jsx","32":"component---src-pages-resources-jsx","33":"component---src-pages-resources-old-jsx","34":"component---src-pages-resources-uk-jsx","35":"component---src-pages-retention-vs-wunderkind-jsx","36":"component---src-pages-security-profile-jsx","37":"component---src-pages-self-service-platform-tos-jsx","38":"component---src-pages-wunderkind-eu-visitor-jsx","39":"component---src-templates-about-us-jsx","40":"component---src-templates-about-us-uk-jsx","41":"component---src-templates-blog-jsx","42":"component---src-templates-case-study-jsx","43":"component---src-templates-case-study-uk-jsx","44":"component---src-templates-client-referral-jsx","45":"component---src-templates-client-referral-thank-you-jsx","46":"component---src-templates-client-referral-thank-you-uk-jsx","47":"component---src-templates-client-referral-uk-jsx","48":"component---src-templates-competitor-jsx","49":"component---src-templates-competitor-uk-jsx","50":"component---src-templates-consumer-insights-hub-jsx","51":"component---src-templates-culture-jsx","52":"component---src-templates-culture-uk-jsx","53":"component---src-templates-industry-jsx","54":"component---src-templates-inner-page-jsx","55":"component---src-templates-inner-page-uk-jsx","56":"component---src-templates-lookbook-js","57":"component---src-templates-lookbook-post-js","58":"component---src-templates-lookbook-uk-js","59":"component---src-templates-our-vision-jsx","60":"component---src-templates-performance-marketing-marketo-jsx","61":"component---src-templates-plain-content-jsx","62":"component---src-templates-plain-content-uk-jsx","63":"component---src-templates-podcast-jsx","64":"component---src-templates-podcast-uk-jsx","65":"component---src-templates-resource-get-started-jsx","66":"component---src-templates-resource-jsx","67":"component---src-templates-resource-uk-jsx","68":"component---src-templates-resources-jsx","69":"component---src-templates-resources-uk-jsx","70":"component---src-templates-solutions-jsx","71":"component---src-templates-solutions-uk-jsx","72":"component---src-templates-unsubscribe-confirmation-jsx","73":"component---src-templates-unsubscribe-confirmation-uk-jsx","74":"component---src-templates-unsubscribe-jsx","75":"component---src-templates-unsubscribe-uk-jsx","76":"component---src-templates-video-jsx","77":"component---src-templates-wkd-bluecore-jsx"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"98e885020a6136661f96","2":"9886faa02bd7503a1a2a","3":"f9b6843e32c7d6156899","4":"39e68d8066e2fb544ee3","5":"89f4be0abb8832f4328b","6":"b42699d7e0c9f0f5f343","7":"a1df884a23f946a48bca","8":"348b6334ef09408602c8","9":"4715ec358b135fb86a3a","10":"781fad060579d0818d82","11":"e9799fc22d6344aaf1c2","12":"eac98791cca1e9dce856","13":"b5831a8a74f75e951d33","14":"2c264008cccef4261bee","15":"895d7260e35bc33619a5","16":"15908f0028a6917f5c61","19":"8ae56e21e86313fba0c0","20":"213da2e1fd4b5a16da70","21":"a017c6b177c47432f5c7","22":"39c55c88d443aa7e4985","23":"f58b2070a0ab20090e50","24":"74cbc6928eef68ca293d","25":"9105e2311ec979e69c05","26":"c849ce63ba5ca9e46c12","27":"aed8f15973079036c75c","28":"4873c8105dbf69cfa7f6","29":"369017ce29c208e834fe","30":"decef0c88f32971d0987","31":"91a3ac036e80587ed9a6","32":"f9fe28dbe46397e61e54","33":"463bb05c419c282f7c71","34":"f3d708df61119aaa81bd","35":"354540bc2f36dec0f618","36":"1e35ca99d3b3ddc1c088","37":"21e7e6d34980b6f59434","38":"cf325cd5085fb8827d73","39":"0580f1015d498cffd390","40":"ad57eea50880b5bf5c00","41":"722aeaab42676329b22f","42":"c20af890b8397cc885d2","43":"c0842e7e5044926b37db","44":"b1d9f684eff3cf1edc7a","45":"34bcd59b7c675b43dd50","46":"d091a7d936e5e93315fb","47":"845998713211ab393690","48":"8d0b31a2cfb52d4227f6","49":"d09a75c359ca2e660b21","50":"79cf6a70e1dd2145305b","51":"6a6aac8cff9cdf744bc9","52":"46a095f8decd2bb4ce14","53":"0aca5ecf4aa60351be68","54":"fb7e73e0ca1e70e37227","55":"1f13641ed85045833108","56":"04c4de8816756732cb8f","57":"ebf74997df380e881751","58":"2397e7677e45bea6d92b","59":"d82714ae1765f5636da7","60":"da10a103b3f07e55177a","61":"56ae96b9b7cc4264c2e9","62":"f9c8ccd6ff259a2a7549","63":"a38e27b09fba06c05294","64":"06dff341adddc94e2f0e","65":"3e8cb50a68fad05cbffe","66":"912abb453f7ed5c8a387","67":"7d7469c4e53170991eee","68":"a23c657c7701d7bcb9bd","69":"717c4142ae2097cd915a","70":"4523f570e640e84dbbdd","71":"476659e834d47667e78c","72":"02d0d009063785b2a5d0","73":"9344fb8897c556e3dc48","74":"65209f824b275bf6e452","75":"f080583c7f6ee13a7247","76":"59dcd7c3f64f84d478ce","77":"d1271f72206fb7709ab9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"3389bff6287b4aeb654cc1f98a9267e7b42ee792","2":"7d3cbdf950d0a3bde754ba91eef34b965482edc6","3":"042631c427225e9cd2a5bcdbef5b3947ed27bf0c","4":"44cb58f2e6fcd2eb1a10482fdb18678762f45c15","5":"2e8e49993f43d1471daa31bd457ab8637269faad","6":"a4c92b5b","7":"f6d80b4e5bec7b791e989e1ab0e7288987f02f86","8":"7b209c3345d92abea6b160ffa2ab4dd01c3e6770","9":"a656cea4aeabd6d651c8f2159ba06833a393a493","10":"520d75254f688c45e52c1ae1f8615bb0a18b23ce","11":"775cbc166ccb32e641d59a874a2b48a4fb904795","12":"2293bb39a1229e2750f5acea87b7c8dedaf35036","13":"323e1820c5c978307575aa5c47801f0a64af9d3a","14":"6264b85f94d8b35da7cf020631ed05257c2868ad","15":"92581cf2c0a22e44ef923c0536027b96abf22498","16":"e528f9020b5aca1fa3959f28315315893f256883","19":"component---src-pages-404-jsx","20":"component---src-pages-attentive-vs-wunderkind-jsx","21":"component---src-pages-driverevenue-jsx","22":"component---src-pages-driverevenue-workshop-jsx","23":"component---src-pages-how-it-works-advertising-solutions-for-advertisers-and-publishers-jsx","24":"component---src-pages-how-it-works-advertising-solutions-for-advertisers-and-publishers-uk-jsx","25":"component---src-pages-how-it-works-performance-marketing-solutions-for-ecommerce-jsx","26":"component---src-pages-how-it-works-performance-marketing-solutions-for-ecommerce-uk-jsx","27":"component---src-pages-index-jsx","28":"component---src-pages-index-uk-jsx","29":"component---src-pages-listrak-vs-wunderkind-jsx","30":"component---src-pages-open-roles-jsx","31":"component---src-pages-open-roles-uk-jsx","32":"component---src-pages-resources-jsx","33":"component---src-pages-resources-old-jsx","34":"component---src-pages-resources-uk-jsx","35":"component---src-pages-retention-vs-wunderkind-jsx","36":"component---src-pages-security-profile-jsx","37":"component---src-pages-self-service-platform-tos-jsx","38":"component---src-pages-wunderkind-eu-visitor-jsx","39":"component---src-templates-about-us-jsx","40":"component---src-templates-about-us-uk-jsx","41":"component---src-templates-blog-jsx","42":"component---src-templates-case-study-jsx","43":"component---src-templates-case-study-uk-jsx","44":"component---src-templates-client-referral-jsx","45":"component---src-templates-client-referral-thank-you-jsx","46":"component---src-templates-client-referral-thank-you-uk-jsx","47":"component---src-templates-client-referral-uk-jsx","48":"component---src-templates-competitor-jsx","49":"component---src-templates-competitor-uk-jsx","50":"component---src-templates-consumer-insights-hub-jsx","51":"component---src-templates-culture-jsx","52":"component---src-templates-culture-uk-jsx","53":"component---src-templates-industry-jsx","54":"component---src-templates-inner-page-jsx","55":"component---src-templates-inner-page-uk-jsx","56":"component---src-templates-lookbook-js","57":"component---src-templates-lookbook-post-js","58":"component---src-templates-lookbook-uk-js","59":"component---src-templates-our-vision-jsx","60":"component---src-templates-performance-marketing-marketo-jsx","61":"component---src-templates-plain-content-jsx","62":"component---src-templates-plain-content-uk-jsx","63":"component---src-templates-podcast-jsx","64":"component---src-templates-podcast-uk-jsx","65":"component---src-templates-resource-get-started-jsx","66":"component---src-templates-resource-jsx","67":"component---src-templates-resource-uk-jsx","68":"component---src-templates-resources-jsx","69":"component---src-templates-resources-uk-jsx","70":"component---src-templates-solutions-jsx","71":"component---src-templates-solutions-uk-jsx","72":"component---src-templates-unsubscribe-confirmation-jsx","73":"component---src-templates-unsubscribe-confirmation-uk-jsx","74":"component---src-templates-unsubscribe-jsx","75":"component---src-templates-unsubscribe-uk-jsx","76":"component---src-templates-video-jsx","77":"component---src-templates-wkd-bluecore-jsx"}[chunkId]||chunkId) + "." + {"0":"c78e198492e1d5aa96c1","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
